<template>
	<div class="masters">
		<SubHeader title="ODO Masters" subtitle="ODOマスターズ" />

		<div class="container">
			<ul class="nav nav-pills mb-3" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link" href="/masters/2026/"> 2026（2025年度）</a>
				</li>
				<li class="nav-item">
					<a class="nav-link active" href="javascript:void(0);">
						2025（2024年度）
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/masters/2024/"> 2024（2023年度）</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/masters/2023/"> 2023（2022年度）</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" href="/masters/2020/"> 2020（2019年度） </a>
				</li>
			</ul>

			<div class="row justify-content-center">
				<div class="col-lg-12">
					<h2>ODOマスターズ2025（2024年度）</h2>
					<h5>開催：2025年7月21日（月祝）、会場：住吉大社（吉祥殿）</h5>
				</div>
			</div>

			<div class="row d-flex align-items-end mb-4">
				<div class="col-6 offset-3 text-center">
					<p>
						<span class="rank_winner"><i class="fas fa-medal"></i>Winner</span>
						<img
							src="/images/masters/2025/odomasters_01.jpg"
							class="img-fluid"
							@click="openGallery(0)"
						/>
						<span class="name">高山 得溶</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_2nd"><i class="fas fa-medal"></i>2nd</span>
						<img
							src="/images/masters/2025/odomasters_02.jpg"
							class="img-fluid"
							@click="openGallery(1)"
						/>
						<span class="name">髙橋 綾也</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_3rd"><i class="fas fa-medal"></i>3rd</span>
						<img
							src="/images/masters/2025/odomasters_03.jpg"
							class="img-fluid"
							@click="openGallery(2)"
						/>
						<span class="name">角田 慶次</span>
					</p>
				</div>
				<div class="col-4 text-center">
					<p>
						<span class="rank_3rd"><i class="fas fa-medal"></i>3rd</span>
						<img
							src="/images/masters/2025/odomasters_04.jpg"
							class="img-fluid"
							@click="openGallery(3)"
						/>
						<span class="name">外筬 久人</span>
					</p>
				</div>
			</div>

			<h4>集合写真＆決勝トーナメント表</h4>
			<div class="row mb-4">
				<div class="col-5 text-center offset-1">
					<p>
						<span class="rank">集合写真</span>
						<img
							src="/images/masters/2025/odomasters_05.jpg"
							class="img-fluid"
							@click="openGallery(4)"
						/>
					</p>
				</div>
				<div class="col-5 text-center">
					<p>
						<span class="rank">決勝トーナメント表</span>
						<img
							src="/images/masters/2025/odomasters_12.jpg"
							class="img-fluid"
							@click="openGallery(5)"
						/>
					</p>
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_06.jpg"
							class="img-fluid"
							@click="openGallery(6)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_07.jpg"
							class="img-fluid"
							@click="openGallery(7)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_08.jpg"
							class="img-fluid"
							@click="openGallery(8)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_09.jpg"
							class="img-fluid"
							@click="openGallery(9)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_10.jpg"
							class="img-fluid"
							@click="openGallery(10)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_11.jpg"
							class="img-fluid"
							@click="openGallery(11)"
						/>
					</p>
				</div>
				<div class="col-4">
					<p>
						<img
							src="/images/masters/2025/odomasters_13.jpg"
							class="img-fluid"
							@click="openGallery(12)"
						/>
					</p>
				</div>
			</div>

			<h4>エントリー</h4>
			<div class="row">
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/01_kurokawa.jpg" class="img-fluid" />
						<span class="name">黒川 智成</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/02_takayama.jpg" class="img-fluid" />
						<span class="name">高山 得溶</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/03_sotoosa.jpg" class="img-fluid" />
						<span class="name">外筬 久人</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/04_imoto.jpg" class="img-fluid" />
						<span class="name">井本 隆之</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/05_isowa.jpg" class="img-fluid" />
						<span class="name">磯和 勇希</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/06_den.jpg" class="img-fluid" />
						<span class="name">田 達輝</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/07_asai.jpg" class="img-fluid" />
						<span class="name">浅井 佑介</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/08_takeuchi.jpg" class="img-fluid" />
						<span class="name">竹内 英人</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/09_odachi.jpg" class="img-fluid" />
						<span class="name">大達 浩司</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img
							src="/images/masters/2025/10_yoshimura.jpg"
							class="img-fluid"
						/>
						<span class="name">芳村 幹陽</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/11_ohashi.jpg" class="img-fluid" />
						<span class="name">大橋 操</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img
							src="/images/masters/2025/12_shirohata.jpg"
							class="img-fluid"
						/>
						<span class="name">白畑 諒大</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/13_komura.jpg" class="img-fluid" />
						<span class="name">小村 亮</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/14_hayashi.jpg" class="img-fluid" />
						<span class="name">林 成光</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/15_usuzawa.jpg" class="img-fluid" />
						<span class="name">臼沢 晋</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/16_obara.jpg" class="img-fluid" />
						<span class="name">小原 開翔</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img
							src="/images/masters/2025/17_takahashi.jpg"
							class="img-fluid"
						/>
						<span class="name">髙橋 綾也</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/18_takayama.jpg" class="img-fluid" />
						<span class="name">高山 俊太</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/19_tsuruno.jpg" class="img-fluid" />
						<span class="name">鶴野 海斗</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/20_sumida.jpg" class="img-fluid" />
						<span class="name">角田 慶次</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/no_image.jpg" class="img-fluid" />
						<span class="name">林 和義</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img
							src="/images/masters/2025/22_matsumoto.jpg"
							class="img-fluid"
						/>
						<span class="name">松本 崇</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/23_yanase.jpg" class="img-fluid" />
						<span class="name">柳瀬 将一</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/no_image.jpg" class="img-fluid" />
						<span class="name">藤城 颯</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/25_kurata.jpg" class="img-fluid" />
						<span class="name">倉田 朗央</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/no_image.jpg" class="img-fluid" />
						<span class="name">石森 英彦</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/27_tanida.jpg" class="img-fluid" />
						<span class="name">谷田 尚嗣</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/28_hisamoto.jpg" class="img-fluid" />
						<span class="name">久本 真之</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img
							src="/images/masters/2025/29_hashikawa.jpg"
							class="img-fluid"
						/>
						<span class="name">橋川 大晶</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/30_kiyoi.jpg" class="img-fluid" />
						<span class="name">清井 寛司</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/31_sunakawa.jpg" class="img-fluid" />
						<span class="name">砂川 祥輝</span>
					</p>
				</div>
				<div class="col-lg-2 col-3 text-center">
					<p>
						<img src="/images/masters/2025/32_iwatani.jpg" class="img-fluid" />
						<span class="name">岩谷 由人</span>
					</p>
				</div>
			</div>

			<!--<h4 class="mt-5">エントリー</h4>
			<div class="row mb-5">
				<div class="col-lg-6 col-12">
					<table class="table table-striped">
						<thead class="thead-dark">
							<tr>
								<th scope="col" class="text-nowrap">Player</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(player, index) in list">
								<tr
									v-if="
										player != null &&
										player.number != '' &&
										player.attendance != ''
									"
									:key="'rank' + index"
								>
									<td class="text-nowrap">{{ player.player_name }}</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>-->

			<LightBox
				ref="lightbox"
				:media="media"
				:show-light-box="false"
				:show-caption="true"
			></LightBox>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import SubHeader from "@/components/common/SubHeader.vue";
//import VueLazyLoad from "vue-lazyload";
import Loading from "vue-loading-overlay";
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

export default {
	name: "masters",
	components: {
		SubHeader,
		LightBox,
	},
	data() {
		return {
			isLoading: true,
			list: [],
			media: [
				{
					thumb: "/images/masters/2025/odomasters_01.jpg",
					src: "/images/masters/2025/odomasters_01.jpg",
					caption: "高山 得溶",
				},
				{
					thumb: "/images/masters/2025/odomasters_02.jpg",
					src: "/images/masters/2025/odomasters_02.jpg",
					caption: "髙橋 綾也",
				},
				{
					thumb: "/images/masters/2025/odomasters_03.jpg",
					src: "/images/masters/2025/odomasters_03.jpg",
					caption: "角田 慶次",
				},
				{
					thumb: "/images/masters/2025/odomasters_04.jpg",
					src: "/images/masters/2025/odomasters_04.jpg",
					caption: "外筬 久人",
				},
				{
					thumb: "/images/masters/2025/odomasters_05.jpg",
					src: "/images/masters/2025/odomasters_05.jpg",
					caption: "集合写真",
				},
				{
					thumb: "/images/masters/2025/odomasters_12.jpg",
					src: "/images/masters/2025/odomasters_12.jpg",
					caption: "決勝トーナメント表",
				},
				{
					thumb: "/images/masters/2025/odomasters_06.jpg",
					src: "/images/masters/2025/odomasters_06.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_07.jpg",
					src: "/images/masters/2025/odomasters_07.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_08.jpg",
					src: "/images/masters/2025/odomasters_08.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_09.jpg",
					src: "/images/masters/2025/odomasters_09.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_10.jpg",
					src: "/images/masters/2025/odomasters_10.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_11.jpg",
					src: "/images/masters/2025/odomasters_11.jpg",
					caption: "",
				},
				{
					thumb: "/images/masters/2025/odomasters_13.jpg",
					src: "/images/masters/2025/odomasters_13.jpg",
					caption: "",
				},
			],
		};
	},
	mounted: function () {
		//this.getData();
	},
	methods: {
		getData: function () {
			this.isLoading = true;
			let loader = this.$loading.show({
				// Optional parameters
				container: this.fullPage ? null : this.$refs.formContainer,
				canCancel: false,
				color: this.$store.state.primary_color,
				backgroundColor: "#666",
			});
			let params = {};
			this.axios
				.get(
					"https://script.google.com/macros/s/AKfycbw2ph-kgRHspt8DVaDk5kuTH-OWDSpIl2mWsr9ZFbGCs_ZJONj25TC7JQ_FZUVBqlQ/exec",
					{
						params: params,
					}
				)
				.then((res) => {
					//console.log("res:" + JSON.stringify(res.data));
					this.list = res.data.list;
					// simulate AJAX
					setTimeout(() => {
						loader.hide();
						this.isLoading = false;
					}, 500);
				});
		},
		openGallery(index) {
			this.$refs.lightbox.showImage(index);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.6rem;
	margin-bottom: 1rem;
}
h4 {
	border-bottom: solid 3px #333;
	padding-bottom: 5px;
	margin-bottom: 2rem;
	position: relative;
	&:before {
		content: "";
		width: 3rem;
		height: 3px;
		background-color: $primary-color;
		display: block;
		position: absolute;
		left: 0;
		bottom: -3px;
	}
}
.container {
	padding: 4rem 1rem;
	text-align: left;
}
.rank,
.rank_winner,
.rank_2nd,
.rank_3rd,
.name {
	color: #333;
}
.rank_winner {
	font-size: 2rem;
	::v-deep i,
	::v-deep svg {
		color: #dbb400;
	}
}
.rank_2nd {
	font-size: 1.4rem;
	::v-deep i,
	::v-deep svg {
		color: #9fa0a0;
	}
}
.rank_3rd {
	font-size: 1.4rem;
	::v-deep i,
	::v-deep svg {
		color: #c47022;
	}
}
i {
	margin-right: 0.6rem;
}
</style>
